import React from 'react';

const PARTNERS = [
    { name: 'River Capital', logo: require('../../../../images/landing-pages/home-page/partner-logos/RIVERCAPITAL_LOGO.png') },
    { name: 'British Design Fund', logo: require('../../../../images/landing-pages/home-page/partner-logos/BRITISH_DESIGN_FUND_LOGO.png') },
    { name: 'Deepbridge', logo: require('../../../../images/landing-pages/home-page/partner-logos/Deepbridge_logo.png') },
    { name: 'Foresight', logo: require('../../../../images/landing-pages/home-page/partner-logos/Foresight_logo.png') },
    { name: 'Northern Gritstone', logo: require('../../../../images/landing-pages/home-page/partner-logos/NORTHERN_GRITSTONE_LOGO.png') },
    { name: 'YFM Equity Partners', logo: require('../../../../images/landing-pages/home-page/partner-logos/YFM_Equity_logo.png') },
    { name: 'SolidBond', logo: require('../../../../images/landing-pages/home-page/partner-logos/SolidBond_logo.png') },
    { name: 'Northstar Ventures', logo: require('../../../../images/landing-pages/home-page/partner-logos/Northstar_Ventures_logo.png') },
    { name: 'ACF Investors', logo: require('../../../../images/landing-pages/home-page/partner-logos/ACFInvestors_logo.png') },
    { name: 'Key Fund', logo: require('../../../../images/landing-pages/home-page/partner-logos/key_fund_logo.png') },
];

const HomeLogoStrip = () => (
    <section className="lp-logos-sec">
        <p className="lp-logos-eyebrow">Trusted by 50+</p>
        <h2 className="lp-logos-title">Our Partners</h2>
        <div className="lp-logos-strip">
            <div className="lp-logos-track">
                {[...PARTNERS, ...PARTNERS].map((partner, i) => (
                    <span className="lp-logo-chip" key={i}>
                        <img src={partner.logo} alt={partner.name} />
                    </span>
                ))}
            </div>
        </div>
    </section>
);

export default HomeLogoStrip;
